import React from 'react'
import { StyledForm } from './styles'

export default function StyledFilterForm({ ...props }) {
  return <StyledForm {...props} />
}
